<div class="link-cell-container">
  <ng-container *ngFor="let icon of icons">
    <ins-icon-container [icon]="icon" [data]="data"></ins-icon-container>
  </ng-container>
    <ins-overflow-span
      [content]="textValue"
      (click)="textClick($event)"
      class="hyperlink ins-body-2"
    >
    </ins-overflow-span>
</div>
